import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter as Router, Routes, Route } from "react-router-dom"; // Use HashRouter for GitHub Pages
import App from "./App";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min'; // Bootstrap JS
import './index.css'; // Custom styles if needed
import './i18n'; // Import i18n configuration

// Root element
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      {/* Define all routes */}
      <Routes>
        {/* Main App with nested routes */}
        <Route path="/" element={<App />}>
          <Route index element={<Home />} /> {/* Default Route: Home */}
          <Route path="contact" element={<Contact />} /> {/* Contact Page */}
          <Route path="about" element={<About />} /> {/* About Page */}
        </Route>
      </Routes>
    </Router>
  </React.StrictMode>
);
